import { Checkbox, CheckboxProps } from 'antd';
import React from 'react';

const MfaReset = (props: CheckboxProps) => {
  return (
    <div>
      <span style={{ marginRight: 10 }}>Multi-Factor Authentication Reset</span>
      <Checkbox {...props} />
    </div>
  );
};

export default MfaReset;
